import store from '@/stores/store';
import allocations from './submodules/allocations';
import utils from '@/stores/utils';

const { getStorageKey } = utils;

const state = {

};

const mutations = {

};

const actions = {

    async init({ commit, dispatch, state }, params) {
        dispatch('allocations/init', {
            filters: {},
        });
        if (store.getters['session/current_user_permissions'].indexOf("order.view_allocation") != -1) {
            dispatch('allocations/fetchAllocations');
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        allocations: allocations({
            storageKey: getStorageKey('allocations', 'default'),
            fieldsToSave: undefined // Save all filters
        }),
    }
};
